import { colors } from "../../theme/colors";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const MgpText = styled(Typography)(({ theme }) => ({}));
